import { createFileRoute } from "@tanstack/react-router";

import { Landing } from "../components/Landing";
import { landingHead } from "../lib/marketing/head";
import { loadMarketingBundle } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/**
 * The landing page in English, at the site root.
 *
 * English has no `/en` of its own (see `lib/marketing/registry.ts`): this URL is
 * what the App Store listing's marketing URL points at, what every share link
 * and QR code resolves to, and what `x-default` names. A second address for the
 * same page would split that between two URLs and gain nothing.
 *
 * The copy is fetched in the loader rather than imported so the nine
 * translations stay in nine chunks; `head` reads it back out of `loaderData`,
 * which is what lets the title and description be in the page's own language
 * instead of English with a translated body under it.
 */
export const Route = createFileRoute("/")({
  loader: () => loadMarketingBundle("en"),
  headers: documentHeaders,
  head: ({ loaderData }) => (loaderData ? landingHead("en", loaderData) : {}),
  component: Home,
});

function Home() {
  const bundle = Route.useLoaderData();
  return <Landing bundle={bundle} lang="en" />;
}
